import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder } from '@angular/forms';
import { ApiService } from '../../../services/api.service';
import { UiService } from '../../../services/ui.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MIN_PASSWORD_LENGTH } from '../../../shared/constants';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { FormHelper } from '../../../shared/form-helper';
import { TranslocoService } from '@ngneat/transloco';

enum PageModes {
  Password = 'password',
  Success = 'success',
}

@Component({
  selector: 'app-password-renew-password',
  templateUrl: './password-renew-password.component.html',
  styleUrls: ['./password-renew-password.component.scss']
})
export class PasswordRenewPasswordComponent implements OnInit {

  public form: UntypedFormGroup = this.fb.group({
    onetime: new UntypedFormControl('', [Validators.required]),
    new: new UntypedFormControl(''),
    confirm: new UntypedFormControl(''),
  }, {
    validators: [this.passwordValidator]
  });
  public errors = null;
  public busy = false;
  public messages: Array<any> = [];
  public mode: PageModes = PageModes.Password;
  private email: string;

  public PageModes = PageModes;
  public faCheck = faCheckCircle;

  constructor(
    private fb: UntypedFormBuilder,
    private api: ApiService,
    private ui: UiService,
    private router: Router,
    private route: ActivatedRoute,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params.email) {
        this.email = params.email;
      } else {
        this.router.navigate(['/login']);
      }
    });
  }

  public onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid) {
      this.busy = true;
      const payload: any = this.form.value;
      payload.email = this.email;
      this.api.renewPassword(payload).subscribe(
        () => {
          this.mode = PageModes.Success;
        },
        () => {
          this.ui.showMessage('error', this.transloco.translate('password.error_on_password_change'), this.transloco.translate('common.error'));
        }
      ).add(() => {
          this.busy = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  private passwordValidator(group: UntypedFormGroup): void {
    const password = group.get('new')?.value;
    const password2 = group.get('confirm')?.value;
    group.get('new').setErrors(null);
    group.get('confirm').setErrors(null);
    if (!password) {
      group.get('new')?.setErrors({ required: true });
    } else {
      const errors = [];
      if (password.length < MIN_PASSWORD_LENGTH) {
        errors.push('passwordLength');
      }
      if (!(/\d/.test(password) && /[A-Z]/.test(password) && /[a-z]/.test(password))) {
        errors.push('passwordStrength');
      }
      if (errors.length > 0) {
        const errorList = {};
        errors.forEach((error: string) => {
          errorList[error] = true;
        });
        group.get('new')?.setErrors(errorList);
      } else {
        group.get('new')?.setErrors(null);
      }
      if (!password2) {
        group.get('confirm')?.setErrors({ required: true });
      } else if (password !== password2) {
        group.get('confirm')?.setErrors({ passwordMatch: true });
      }
    }
  }

}
